import React from 'react';

import RegisterPadron from 'views/Payments/components/RegisterPadron';
import { useNavigate } from 'react-router';
import useQuery from 'hooks/useQuery';
import { AUTH_CONTRIBUYENTE } from 'utils/env';

const SignIn = () => {
  const navigate = useNavigate();
  const redirect = useQuery(['redirect']);
  const redirectParam = redirect ? `?redirect=${redirect}` : '';
  const toLogin = '/mi-cuenta/login'.concat(redirectParam);

  const onRegister = async ({ rfc }) => navigate(toLogin, { state: { rfc } });

  return (
    <RegisterPadron
      tipoDePadron={AUTH_CONTRIBUYENTE ? 15 : 1}
      callback={onRegister}
      onCancel={() => navigate('/mi-cuenta')}
    />
  );
};

export default SignIn;
